import { render, staticRenderFns } from "./passBack.vue?vue&type=template&id=421b4538&scoped=true&"
import script from "./passBack.vue?vue&type=script&lang=js&"
export * from "./passBack.vue?vue&type=script&lang=js&"
import style0 from "./passBack.vue?vue&type=style&index=0&id=421b4538&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421b4538",
  null
  
)

export default component.exports